<template>
  <form-group v-bind="$attrs">
    <v-row>
      <v-col cols="6">
        <bloqueio-options :payload="payload" />
      </v-col>
      <v-col cols="6">
        <input-select
          id="input:idConfigBoleto"
          v-model="payload.idConfigBoleto"
          :items="idConfigBoletoOptions"
          :rules="[requiredRule]"
          label="Configuração de boleto"
          :loading="loading"
          required
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="6"
      >
        <input-select
          id="input:indBaixarAposVencimento"
          v-model="payload.indBaixarAposVencimento"
          :items="indBaixarAposVencimentoOptions"
          label="Baixar após vencimento"
        />
      </v-col>
      <v-col
        cols="6"
      >
        <input-text
          id="input:numDiasVencimento"
          v-model="payload.numDiasVencimento"
          label="Dias vencimento"
          type="number"
        />
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import InvoiceConfigRequest from '@/app/modules/cardhub/invoice/config/InvoiceConfigRequest';
import NotificationMixin from '@/app/arch/mixins/NotificationMixin';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RequestSelectMixin from '@/app/arch/mixins/RequestSelectMixin';
import BloqueioOptions from '../inputs/BloqueioOptions.vue';

export default {
  name: 'ProdutoBoleto',
  components: {
    BloqueioOptions,
    FormGroup,
  },
  mixins: [NotificationMixin, RulesMixin, RequestSelectMixin],
  props: {
    payload: {
      type: Object,
      default() {
        return {
          id: '',
          idRegionalMarca: '',
          indBloqueado: '',
          txtObservacao: '',
          descricaoValor: '',
          tipoValorProduto: '',
          vlrProdutoServico: '',
          vlrVariavelMin: '',
          vlrVariavelMax: '',
          idConfigBoleto: '',
          indBaixarAposVencimento: '',
          numDiasVencimento: '',
        };
      },
    },
  },
  data: () => ({
    requestClass: InvoiceConfigRequest,
    loading: false,
    idConfigBoletoOptions: [],
    indBaixarAposVencimentoOptions: [
      {
        value: true,
        text: 'Sim',
      },
      {
        value: false,
        text: 'Não',
      },
    ],
    invoiceMessageError: 'Falha ao buscar configurações de boletos',
  }),
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.makeRequest();
    },
    makeRequest() {
      this.serviceCall(
        this.requestClass.list(
          this.makeParams(),
        ),
        this.setDataOptions(
          'idConfigBoletoOptions',
          'invoiceTypeDescription',
        ),
        this.invoiceMessageError,
        this.requestCallBack,
      );
    },
    requestCallBack() {
      this.loading = false;
    },
  },
};
</script>
